const Module = () => import('./Module.vue')
const TeamRating = () => import('./views/team-rating.vue')

const moduleRoute = {
  path: '/team-rating',
  component: Module,
  children: [
    {
      path: '',
      component: TeamRating
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
